const config = {
  contentful: {
    accessToken: 'oKnPnLrgUVk8H5JkQYwXnmRDqoHO33--BzmTxPpRcfw',
    space: '9y4fi2gkk4ov',
    environment: 'master',
  },
  nacelle: {
    accessToken: 'a3a62319-281d-4eea-a522-08e9bd35dbcf',
    endpoint:
      'https://storefront.api.nacelle.com/graphql/v1/spaces/7fc652a4-837e-4b61-917b-1e4592546e01',
  },
  ninetailed: {
    previewPlugin: {
      clientId: '79e33a8f-9ff5-4ef2-963f-9865902d9904',
      secret: '5e0906fa-08d5-4271-9848-e3e4bfa08086',
    },
    provider: {
      clientId: '959454bc-e4e6-4088-9861-937af542b86e',
      environment: 'main',
    },
  },
  searchspring: {
    siteId: 'q8q4eu',
  },
  defaultLocale: 'en-US',
};

export default config;
